/**
 * M-02: Allowlist for /blank?id=... internal redirect. Only these paths (or subpaths) are allowed.
 * Reject protocol strings, double slashes, and path traversal.
 */
export const BLANK_REDIRECT_ALLOWED_PREFIXES = [
  '/operational/dashboard',
  '/operational/kyc',
  '/operational/kyb',
  '/operational/users',
  '/operational/fee',
  '/operational/newFee',
  '/operational/merchantApi',
  '/operational/transactions',
  '/operational/error-cases',
  '/operational/return-required',
  '/operational/funds-freeze',
  '/operational/freeze-history',
  '/operational/fee-history',
  '/operational/limits-list',
  '/operational/pix-keys',
  '/operational/med',
  '/operational/infractions',
  '/operational/infractions-automation',
  '/operational/apix',
  '/operational/logs',
  '/access-control',
  '/financial/dashboard',
  '/financial/str-calendar',
  '/login',
  '/change-pwd',
]

const LEGACY_BLANK_REDIRECT_PATHS = {
  '/dashboard': '/operational/dashboard',
  '/kyc': '/operational/kyc',
  '/kyb': '/operational/kyb',
  '/fee': '/operational/fee',
  '/logs': '/operational/logs',
  '/med': '/operational/med',
  '/infractions': '/operational/infractions',
  '/pix-keys': '/operational/pix-keys',
  '/limits-list': '/operational/limits-list',
  '/error-cases': '/operational/error-cases',
  '/transactions': '/operational/transactions',
  '/merchantApi': '/operational/merchantApi',
  '/users': '/operational/users',
  '/operational/access-control': '/access-control',
}

export const parseBlankRedirectId = id => {
  if (Array.isArray(id)) {
    return id[0]
  }
  return id
}

export const normalizeBlankRedirectPath = path => {
  const parsed = parseBlankRedirectId(path)
  if (parsed == null || typeof parsed !== 'string') {
    return ''
  }

  const trimmed = parsed.trim()
  if (!trimmed) {
    return ''
  }

  if (LEGACY_BLANK_REDIRECT_PATHS[trimmed]) {
    return LEGACY_BLANK_REDIRECT_PATHS[trimmed]
  }

  if (trimmed.startsWith('/users/')) {
    return `/operational${trimmed}`
  }

  if (trimmed.startsWith('/transactions/')) {
    return `/operational${trimmed}`
  }

  if (trimmed.startsWith('/med/')) {
    return `/operational${trimmed}`
  }

  return trimmed
}

export function isAllowedBlankRedirectId(id) {
  const normalized = normalizeBlankRedirectPath(id)
  if (!normalized) return false
  if (normalized.includes(':')) return false
  if (normalized.includes('//')) return false
  if (normalized.includes('..')) return false
  if (!normalized.startsWith('/')) return false

  return BLANK_REDIRECT_ALLOWED_PREFIXES.some(
    prefix => normalized === prefix || normalized.startsWith(`${prefix}/`),
  )
}
